import type { SupportTicketMigratedFromV1EventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import RefreshIcon from "@redotech/redo-icons/refresh-cw-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

const formatCount = (count: number, noun: string) =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

export const SupportTicketMigratedFromV1Event = memo(
  function SupportTicketMigratedFromV1Event({
    event,
    data,
  }: {
    event: SupportTicketTimelineEventResponse;
    data: SupportTicketMigratedFromV1EventData;
  }) {
    return (
      <Flex align="flex-start" className={styles.card} gap="sm">
        <Flex
          align="center"
          className={`${styles.icon} ${styles.iconGrayBlue}`}
          justify="center"
        >
          <RefreshIcon />
        </Flex>
        <Flex className={styles.content} dir="column" gap="xxs">
          <Text fontSize="xs" fontWeight="medium" textColor="primary">
            Migrated from Support v1
          </Text>
          <Text className={styles.details} fontSize="xxs" textColor="secondary">
            {formatCount(data.messagesMigrated, "message")},{" "}
            {formatCount(data.threadsMigrated, "thread")},{" "}
            {formatCount(
              data.legacyTimelineEventsMigrated,
              "legacy timeline event",
            )}
          </Text>
          <EventTimestamp event={event} />
        </Flex>
      </Flex>
    );
  },
);
